import React from 'react';
import { Switch } from 'react-router';
import { UserRoute } from '../components';
import { NewTeacher, AddInstitue, UserDashboard, MyClasses, MyClassroom, MyClass } from '../views'

const UserRoutes = () => {
    return (<Switch>
        <UserRoute exact path="/add-my-institute" component={AddInstitue} />
        <UserRoute exact path="/teacher/:token/form" component={NewTeacher} />
        <UserRoute exact path="/user/dashboard" component={UserDashboard} />
        <UserRoute exact path="/user/classes" component={MyClasses} />
        <UserRoute exact path="/my/:id/classroom" component={MyClassroom} />
        <UserRoute exact path="/my/:id/class" component={MyClass} />
    </Switch>);
};

export default UserRoutes;